import apiRequest from '@/utils/apiRequest';
import type { WebPage } from '@/types/page';

interface PageResponse {
  key: string;
  title: string;
  description?: string;
  componentsPublished: WebPage['components'];
  status: string;
  createDate: string;
  updateDate: string;
}

/**
 * 获取已发布的页面（前端渲染）
 * @param key 页面唯一标识
 * @param options 请求选项
 */
export async function getPublishedPage(
  key: string,
  options?: { signal?: AbortSignal; cookie?: string }
): Promise<WebPage> {
  try {
    const response = await apiRequest<PageResponse>(`/public/page/${key}`, {
      method: 'GET',
      ...options,
    });

    // 映射后端字段: componentsPublished -> components
    return {
      key: response.key,
      title: response.title,
      description: response.description,
      components: response.componentsPublished || [],
      status: response.status,
      createDate: response.createDate,
      updateDate: response.updateDate,
    };
  } catch (error) {
    // 友好的错误提示
    const errorMessage = error instanceof Error ? error.message : String(error);
    if (errorMessage.includes('404') || errorMessage.includes('NotFound')) {
      throw new Error('页面不存在或未发布');
    }
    console.error('获取页面失败:', error);
    throw new Error('加载页面失败，请稍后重试');
  }
}
